const chairs = (t, L, D) => {
  const n = Math.max(0, Math.min(Number(t.posti) || 0, 40));
  if (!n) return [];
  if (t.forma === "rotondo" || t.forma === "ovale") return Array.from({ length: n }, (_, i) => { const a = (i / n) * Math.PI * 2; return [Math.cos(a) * (L / 2 + 0.3), Math.sin(a) * (D / 2 + 0.3)]; });
  const sides = t.sposi ? [[n, -1]] : [[Math.ceil(n / 2), -1], [Math.floor(n / 2), 1]];
  return sides.flatMap(([k, s]) => Array.from({ length: k }, (_, i) => [-L / 2 + (L / k) * (i + 0.5), s * (D / 2 + 0.3)]));
};

const dimsOf = (t) => {
  if (t.forma === "rotondo") { const d = (Number(t.diametro) || 180) / 100; return [d, d]; }
  if (t.forma === "quadrato") { const d = (Number(t.lunghezza) || 120) / 100; return [d, d]; }
  return [(Number(t.lunghezza) || 240) / 100, (Number(t.larghezza) || 100) / 100];
};

function Table({ t, W, H, cop, pill }) {
  const [L, D] = dimsOf(t);
  const num = t.sposi && !t.numero ? "♥" : t.numero || "";
  const r = Math.max(Math.min(L, D) / 2, pill * 1.25);
  const sans = "Plus Jakarta Sans, Arial, sans-serif";
  const label = `${num} x ${cop}`;
  const fsz = pill * 0.9;
  const k = Math.max(1, (fsz * (label.length * 0.58) + pill * 0.5) / L, (fsz * 1.6) / D);
  const [SL, SD] = [L * k, D * k];
  const round = t.forma === "rotondo" || t.forma === "ovale";
  if (cop) {
    return (
      <g transform={`translate(${(t.x / 100) * W} ${(t.y / 100) * H}) rotate(${t.rot || 0})`} data-testid={`staff-label-${t.id}`}>
        {round ? <ellipse rx={SL / 2} ry={SD / 2} fill={t.sposi ? "#F6EBD3" : "#fff"} stroke="#0D2B3A" strokeWidth={pill * 0.14} />
          : <rect x={-SL / 2} y={-SD / 2} width={SL} height={SD} rx={pill * 0.12} fill={t.sposi ? "#F6EBD3" : "#fff"} stroke="#0D2B3A" strokeWidth={pill * 0.14} />}
        <text transform={`rotate(${-(t.rot || 0)})`} textAnchor="middle" dominantBaseline="central" fontFamily={sans} fontWeight="800" fontSize={fsz} fill="#0D2B3A">{label}</text>
      </g>
    );
  }
  return (
    <g transform={`translate(${(t.x / 100) * W} ${(t.y / 100) * H}) rotate(${t.rot || 0})`}>
      {chairs(t, L, D).map(([x, y], i) => <circle key={i} cx={x} cy={y} r="0.22" fill="#fff" stroke="#8FA6B0" strokeWidth="0.04" />)}
      {t.forma === "rotondo" || t.forma === "ovale" ? <ellipse rx={L / 2} ry={D / 2} fill={t.sposi ? "#F6EBD3" : "#fff"} stroke={t.sposi ? "#B08D4F" : "#0D2B3A"} strokeWidth="0.07" />
        : <rect x={-L / 2} y={-D / 2} width={L} height={D} rx="0.08" fill={t.sposi ? "#F6EBD3" : "#fff"} stroke={t.sposi ? "#B08D4F" : "#0D2B3A"} strokeWidth="0.07" />}
      {(
        <g transform={`rotate(${-(t.rot || 0)})`} data-testid={`num-badge-${t.id}`}>
          <circle r={r} fill={t.sposi ? "#B08D4F" : "#0D2B3A"} stroke="#fff" strokeWidth={pill * 0.15} />
          <text textAnchor="middle" dominantBaseline="central" fontFamily={sans} fontWeight="800" fontSize={r * (String(num).length > 2 ? 0.95 : 1.25)} fill="#fff">{num}</text>
        </g>
      )}
    </g>
  );
}

function ScaleBar({ x0, y }) {
  const len = 10;
  const step = len / 4;
  return (
    <g fontFamily="Plus Jakarta Sans, sans-serif" fontSize="0.7" fill="#0D2B3A" transform={`translate(${x0} 0)`}>
      {[0, 1, 2, 3].map((i) => <rect key={i} x={i * step} y={y} width={step} height="0.35" fill={i % 2 ? "#fff" : "#0D2B3A"} stroke="#0D2B3A" strokeWidth="0.04" />)}
      {[0, 1, 2, 3, 4].map((i) => <text key={i} x={i * step} y={y + 1.2} textAnchor="middle">{i * step}</text>)}
      <text x={len + 0.6} y={y + 0.4}>metri</text>
    </g>
  );
}

export function CleanPlan({ plan, tables, svgRef, maskUrl, coperti, interior }) {
  const W = Number(plan.larghezza_m) || 20;
  const H = W * ((plan.img_h || 7) / (plan.img_w || 10));
  const a = plan.analisi;
  const area = a?.area?.length > 2 ? a.area.map(([x, y]) => `${(x / 100) * W},${(y / 100) * H}`).join(" ") : null;
  const zone = a?.mask && a.bbox ? [[a.bbox[0], a.bbox[1]], [a.bbox[2], a.bbox[3]]] : a?.area?.length > 2 ? a.area : null;
  const pts = [...(zone || (tables.length ? [] : [[0, 0], [100, 100]])), ...tables.map((t) => [t.x, t.y]), ...(zone ? (a?.ostacoli || []).map((o) => [o.x, o.y]) : [])];
  const xs = pts.map((p) => (p[0] / 100) * W);
  const ys = pts.map((p) => (p[1] / 100) * H);
  let [x0, y0] = [Math.min(...xs) - 1.5, Math.min(...ys) - 1.5];
  let [x1, y1] = [Math.max(...xs) + 1.5, Math.max(...ys) + 1.5];
  const minW = Math.min(25, W);
  if (x1 - x0 < minW) { const cx = (x0 + x1) / 2; [x0, x1] = [cx - minW / 2, cx + minW / 2]; }
  if (y1 - y0 < minW * 0.6) { const cy = (y0 + y1) / 2; [y0, y1] = [cy - minW * 0.3, cy + minW * 0.3]; }
  return (
    <svg ref={svgRef} xmlns="http://www.w3.org/2000/svg" viewBox={`${x0} ${y0} ${x1 - x0} ${y1 - y0 + 3}`} className="w-full h-auto bg-white" data-testid="clean-plan">
      <rect x={x0} y={y0} width={x1 - x0} height={y1 - y0 + 3} fill="#fff" />
      <defs><filter id="beige"><feColorMatrix type="matrix" values="0 0 0 0 0.96  0 0 0 0 0.937  0 0 0 0 0.902  0 0 0 1 0" /></filter></defs>
      {a?.mask ? (maskUrl && <image href={maskUrl} x="0" y="0" width={W} height={H} preserveAspectRatio="none" filter={interior ? "url(#beige)" : undefined} />) : area ? <polygon points={area} fill={interior ? "#F5EFE6" : "#EEF4E6"} stroke={interior ? "#8A7B66" : "#4E7D5B"} strokeWidth="0.12" /> : <rect x="0" y="0" width={W} height={H} fill="#F7F4EE" stroke="#0D2B3A" strokeWidth="0.12" />}
      {a?.ostacoli?.map((o, i) => (
        <g key={i} transform={`translate(${(o.x / 100) * W} ${(o.y / 100) * H})`}>
          {interior ? <rect x={-o.r_m / 2} y={-o.r_m / 2} width={o.r_m} height={o.r_m} fill="#B8B2A7" /> : <>
            <circle r={o.r_m * 1.5} fill="#C9DEBC" fillOpacity="0.85" stroke="#7FA77A" strokeWidth="0.06" />
            <circle r="0.22" fill="#6B5B45" />
          </>}
        </g>
      ))}
      {tables.map((t) => <Table key={t.id} t={t} W={W} H={H} cop={coperti?.[t.id]} pill={Math.min((x1 - x0) * 0.014, 0.9)} />)}
      <g transform={`translate(${x1 - 1} ${y0 + 1.5})`} fontFamily="Cormorant Garamond, serif" fill="#0D2B3A">
        <path d="M0 -0.2 L0.6 1.6 L0 1.2 L-0.6 1.6 Z" />
        <text y="-0.5" textAnchor="middle" fontSize="0.9" fontWeight="700">N</text>
      </g>
      <ScaleBar x0={x0 + 1} y={y1 + 0.6} />
    </svg>
  );
}

export async function svgToPng(svg, width = 2000) {
  const xml = new XMLSerializer().serializeToString(svg);
  const url = URL.createObjectURL(new Blob([xml], { type: "image/svg+xml" }));
  const img = new Image();
  await new Promise((ok, ko) => { img.onload = ok; img.onerror = ko; img.src = url; });
  const vb = svg.viewBox.baseVal;
  const c = document.createElement("canvas");
  c.width = width;
  c.height = Math.round((width * vb.height) / vb.width);
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, c.width, c.height);
  ctx.drawImage(img, 0, 0, c.width, c.height);
  URL.revokeObjectURL(url);
  return new Promise((ok) => c.toBlob(ok, "image/png"));
}
